import { ACTION_TYPES } from '../../constants';

const initialState = {
  aiKey: null,
  mapKey: null,
  weatherKey: null,
  currentWeather: null,
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_AI_KEY:
      return { ...state, aiKey: action.payload };
    case ACTION_TYPES.SET_MAP_KEY:
      return { ...state, mapKey: action.payload };
    case ACTION_TYPES.SET_WEATHER_KEY:
      return { ...state, weatherKey: action.payload };
    case ACTION_TYPES.SET_CURR_WEATHER:
      return { ...state, currentWeather: action.payload };
    default:
      return state;
  }
};

export default dataReducer;
